import type { PlatformPublicConfig, PublicConfigFromRegistry, PublicConfigRegistry } from './types';
import { getPublicConfig } from './store';

export function createGetConfig<R extends PublicConfigRegistry>(_: R) {
    type TypedConfig = PublicConfigFromRegistry<R> & PlatformPublicConfig;

    return function getConfig<K extends keyof TypedConfig>(key: K): TypedConfig[K] {
        return getPublicConfig()[key as string] as TypedConfig[K];
    };
}

export function getBasePath(): string {
    return getPublicConfig()['basePath'] as string;
}
